/**
 * Collection filter — form submit'i Section Rendering API ile partial update.
 * No JS fallback: native form submit (URL update + full reload).
 *
 * - Filter form: #filter-form (snippet)
 * - Section ID: data-coll-section (main-collection.liquid)
 * - Otomatik submit checkbox/radio change'inde
 */
(() => {
  const form = document.getElementById('filter-form');
  const sectionEl = document.querySelector('[data-coll-section]');
  if (!form || !sectionEl) return;

  const sectionId = sectionEl.dataset.collSection;
  let activeFetch = null;

  const submit = async () => {
    const fd = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of fd.entries()) {
      if (v !== '' && v !== null) params.append(k, v);
    }
    params.set('section_id', sectionId);

    const url = `${window.location.pathname}?${params.toString()}`;

    // URL update (browser back/forward)
    const publicUrl = url.replace(/[?&]section_id=[^&]+/, '');
    history.replaceState(null, '', publicUrl);

    if (activeFetch) activeFetch.abort();
    activeFetch = new AbortController();

    sectionEl.dataset.loading = 'true';

    try {
      const res = await fetch(url, { signal: activeFetch.signal });
      if (!res.ok) throw new Error('filter fetch failed');
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const newSection = tmp.querySelector('[data-coll-section]');
      if (newSection) {
        sectionEl.replaceWith(newSection);
        window.scrollTo({ top: sectionEl.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
      }
    } catch (e) {
      if (e.name === 'AbortError') return;
      // Fail open — submit native
      form.submit();
    } finally {
      sectionEl.dataset.loading = 'false';
    }
  };

  // Auto-submit checkbox/radio/select change'inde
  form.addEventListener('change', (e) => {
    if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
      submit();
    }
  });

  // Price input — submit on blur, ENTER
  form.querySelectorAll('input[type="number"]').forEach((inp) => {
    inp.addEventListener('blur', submit);
    inp.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        submit();
      }
    });
  });

  // Explicit submit btn (uygula)
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    submit();
  });

  // Mobile filter toggle
  const trigger = document.querySelector('[data-cfilter-open]');
  const panel = document.querySelector('[data-cfilter-panel]');
  const close = document.querySelector('[data-cfilter-close]');
  if (trigger && panel) {
    const openPanel = () => {
      panel.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
    };
    const closePanel = () => {
      panel.dataset.open = 'false';
      document.body.style.overflow = '';
    };
    trigger.addEventListener('click', openPanel);
    close?.addEventListener('click', closePanel);
    panel.addEventListener('click', (e) => {
      if (e.target === panel) closePanel();
    });
  }
})();
